/**
 * Flickity Init
 *
 * @since   1.0.0
 * @package hydromassage
 */

(function($) {
	$(document).ready(function() {

		if ( $('.testimonial-slider').length ) {
			$('.testimonial-slider').flickity({
				// options
				autoPlay        : 10000,
				cellAlign       : 'center',
				wrapAround      : true,
				contain         : true,
				prevNextButtons : false,
				pageDots        : false
			});
			$('.testimonial-prev').on( 'click', function() {
			  $('.testimonial-slider').flickity('previous');
			});
			$('.testimonial-next').on( 'click', function() {
			  $('.testimonial-slider').flickity('next');
			});
		}

	}); // document.ready
})(jQuery);
